var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLIke({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 46,
    rx: 10,
    fill: "#6D5FF2",
    fillOpacity: 0.14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 21C34 20.4696 33.7893 19.9609 33.4142 19.5858C33.0391 19.2107 32.5304 19 32 19H25.68L26.64 14.43C26.66 14.33 26.67 14.22 26.67 14.11C26.67 13.7 26.5 13.32 26.23 13.05L25.17 12L18.59 18.58C18.22 18.95 18 19.45 18 20V30C18 30.5304 18.2107 31.0391 18.5858 31.4142C18.9609 31.7893 19.4696 32 20 32H29C29.83 32 30.54 31.5 30.84 30.78L33.86 23.73C33.95 23.5 34 23.26 34 23V21ZM12 32H16V20H12V32Z",
    fill: "#6D5FF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLIke);
export default __webpack_public_path__ + "static/media/lIKE.c18665330b1c456ba18749224d18b627.svg";
export { ForwardRef as ReactComponent };